/**
 * CopilotToolRenderers.tsx
 *
 * Thin orchestrator: calls domain renderer hooks + registers the wildcard
 * fallback. Must be mounted once inside <CopilotKitProvider>.
 *
 * To add a new domain: create renderers/use{Domain}Renderers.ts and call it here.
 */

import { useRenderTool } from "@copilotkit/react-core/v2";
import { usePriorityRenderers } from "./renderers/usePriorityRenderers";
import { useOkrRenderers } from "./renderers/useOkrRenderers";
import { usePeopleRenderers } from "./renderers/usePeopleRenderers";
import { useReportRenderers } from "./renderers/useReportRenderers";
import { WildcardCard, type ToolRenderProps } from "./renderers/renderHelpers";

export function CopilotToolRenderers() {
  // Domain renderer hooks (each registers their named useRenderTool calls)
  usePriorityRenderers();
  useOkrRenderers();
  usePeopleRenderers();
  useReportRenderers();

  // Wildcard fallback — must be last; handles every unmigrated tool
  useRenderTool(
    {
      name: "*",
      render: (props: ToolRenderProps) => <WildcardCard {...props} />,
    },
    [],
  );

  return null;
}
